import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {Playbook} from "../types.ts";
import {I18n} from "@aws-amplify/core";


export const usePlaybooksTableColumns = () => {

    const columns: DataTableColumn<Playbook>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Playbook) => <NavLink to={`/playbooks/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Playbook) => formatTimestamp(item.created),
        },
    ];


    return {
        columns,
    };
};
